import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27eba22d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "devView" }
const _hoisted_2 = ["src"]

import { ref, withDefaults, watch, computed, onMounted } from 'vue';
import * as VideoPlayer from '@/components/VideoPlayer.vue';
import * as LectorCodeViewer from '@/components/LectorCodeViewer.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DevView',
  setup(__props) {


const playbackSessionId = ref<string|null>(null);

function onPlaybackSessionReady(newPlaybackSessionId:string|null) {
	playbackSessionId.value = newPlaybackSessionId;
}

onMounted(() => {
	window.addEventListener('message', (e:MessageEvent) => {
		//console.log(e);
	});
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(VideoPlayer.default, { onOnPlaybackSessionReady: onPlaybackSessionReady }),
    _createElementVNode("iframe", {
      src: `#/view/${playbackSessionId.value}?debug`,
      frameborder: "0",
      width: "100%",
      height: "100%"
    }, null, 8, _hoisted_2)
  ]))
}
}

})